import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { OptionForm } from 'src/components/organisms/option/form';

export const PhotoStudioOptionCreatePage: FC = () => {
  /* 定数宣言 */
  const title = 'オプション登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <OptionForm />
      </Container>
    </Page>
  );
};
